module.exports = __webpack_public_path__ + "774da6180b177a9f8796e702e3d7851a.png";